import { normalizeVoiceText, parseVoiceNumber } from "../voice/ownerVoiceParsers";

export function idOf(value) {
  return String(value?.id || value?._id || value || "");
}

export function localYmd(value = new Date()) {
  const pad = (number) => String(number).padStart(2, "0");
  return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
}

export function spokenDuration(minutes) {
  const total = Math.max(0, Math.round(Number(minutes || 0)));
  if (!total) return "cero minutos";
  if (total < 60) return `${total} minutos`;
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  return `${hours} ${hours === 1 ? "hora" : "horas"}${rest ? ` y ${rest} minutos` : ""}`;
}

export function spokenMoney(value, currency = "ARS") {
  const amount = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 0 }).format(Math.round(Number(value || 0)));
  if (currency === "ARS") return `${amount} pesos`;
  if (currency === "USD") return `${amount} dólares`;
  return `${amount} ${currency}`;
}

export function spokenDate(dateKey) {
  const date = new Date(`${dateKey}T12:00:00`);
  if (Number.isNaN(date.getTime())) return dateKey;
  return new Intl.DateTimeFormat("es-AR", { day: "numeric", month: "long", year: "numeric" }).format(date);
}

export function includesAny(text, phrases = []) {
  return phrases.some((phrase) => text.includes(phrase));
}

export function currencyFromVoice(value = "") {
  const text = normalizeVoiceText(value);
  if (/\b(?:dolar|dolares|usd)\b/.test(text)) return "USD";
  if (/\b(?:euro|euros|eur)\b/.test(text)) return "EUR";
  return "ARS";
}

export function voiceChoiceIndex(raw, length) {
  const value = Math.round(Number(parseVoiceNumber(raw)));
  return value >= 1 && value <= length ? value - 1 : -1;
}

export function entityScore(row, query, fields = ["name"]) {
  const q = normalizeVoiceText(query);
  if (!q) return -1;
  let best = -1;
  fields.forEach((field) => {
    const value = normalizeVoiceText(row?.[field] || "");
    if (!value) return;
    if (value === q) best = Math.max(best, 120);
    else if (value.startsWith(q)) best = Math.max(best, 105);
    else if (value.includes(q)) best = Math.max(best, 92);
    else if (q.includes(value) && value.length >= 4) best = Math.max(best, 84);
    const words = q.split(" ").filter((word) => word.length >= 2);
    const common = words.filter((word) => value.includes(word)).length;
    if (common) best = Math.max(best, 45 + common * 12);
  });
  return best;
}

export function chooseEntity(rows, query, fields = ["name"]) {
  const ranked = (rows || [])
    .map((row) => ({ row, score: entityScore(row, query, fields) }))
    .filter((item) => item.score >= 55)
    .sort((a, b) => b.score - a.score);
  if (!ranked.length) return { row: null, alternatives: [] };
  const ambiguous = ranked.length > 1 && ranked[0].score < 120 && ranked[1].score >= ranked[0].score - 5;
  return { row: ambiguous ? null : ranked[0].row, alternatives: ambiguous ? ranked.slice(0, 3).map((item) => item.row) : [] };
}

export function createOwnerJarvisBriefing() {
  // El modo voz ya no recita un briefing al encenderse.
  // Jarvis habla sólo cuando tiene una respuesta o una pregunta útil.
  return "";
}
